import React from "react";

export function useInterval(callback: CallableFunction, delay: number) {
  const intervalRef = React.useRef<null | number>(null);
  const savedCallback = React.useRef(callback);
  React.useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);
  React.useEffect(() => {
    const tick = () => savedCallback.current();
    intervalRef.current = window.setInterval(tick, delay);
    return () => window.clearInterval(intervalRef.current || undefined);
  }, [delay]);
  return intervalRef;
}
